export const RECENT_SEARCH_VIEWED_LIST = "RECENT_SEARCH_VIEWED_LIST";

export const setRecentSearchViewedList = (object) => {
   return {
      type: RECENT_SEARCH_VIEWED_LIST,
      payload: object,
   };
};
